import {conformToMask} from 'text-mask-core';


class PhoneFormatterService {
	format(phoneNumber: string, showCountry: boolean | null = false) {
		let mask = ['+', /1/, ' ', '(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
		if(showCountry === null) {
			if(!phoneNumber.startsWith('1')) {
				mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
			}
		} else if(showCountry) {
			if(!phoneNumber.startsWith('1')) {
				phoneNumber = '1' + phoneNumber;
			}
		} else if(!showCountry) {
			if(phoneNumber.startsWith('1')) {
				phoneNumber = phoneNumber.substring(1);
				mask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
			}
		}
		const result = conformToMask(phoneNumber, mask, {guide: false});
		return result.conformedValue;
	}
}

export const PhoneFormatter = new PhoneFormatterService();
